import { isArrayLike } from '../../common/commonUtils/isArrayLike.js';
import { isNumber } from '../../common/commonUtils/typeChecks.js';

import { getIndex } from './getIndex.js';

interface IGetItemOptions {
	collection: any[];
	index?: number;
	startIndex?: number;
	endIndex?: number;
}

export function getItem(options: IGetItemOptions): any {
	const { collection, startIndex = 0, endIndex, index } = options;
	if (!isArrayLike(collection) || collection.length <= 0) {
		return;
	}
	const shouldSlice = startIndex > 0 || isNumber(endIndex);
	const workingCollection = shouldSlice ? collection.slice(startIndex, endIndex) : collection;
	if (!isArrayLike(workingCollection) || workingCollection.length <= 0) {
		return;
	}
	if (isNumber(index)) {
		const targetIndex = getIndex({
			targetIndex: index,
			collection: workingCollection,
		});
		if (targetIndex > -1) {
			return workingCollection[targetIndex];
		}
	}
	return workingCollection;
}
